import { render, staticRenderFns } from "./modularChild1.vue?vue&type=template&id=984015a8&scoped=true"
import script from "./modularChild1.vue?vue&type=script&lang=js"
export * from "./modularChild1.vue?vue&type=script&lang=js"
import style0 from "./modularChild1.vue?vue&type=style&index=0&id=984015a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984015a8",
  null
  
)

export default component.exports